import type { NavigatorUserProps } from "./types-navigator-user";
import { useNavigatorUser } from "./use-navigator-user";
import { NavigatorUserView } from "./view-navigator-user";

export function NavigatorUser(props: NavigatorUserProps) {
  const vm = useNavigatorUser(props);

  return <NavigatorUserView {...vm} />;
}

export type * from "./types-navigator-user";
